<script lang="ts">
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  const values = [
    {
      title: 'Open Sourcing',
      desc: 'Butane is an open-source protocol, enhancing transparency and inviting scrutiny.  When the code is openly accessible, a large community of developers, auditors, and users can examine it for vulnerabilities, errors, or malicious elements.',
    },
    {
      title: 'In-Depth Auditing',
      desc: 'External auditors conduct independent assessments of the platform to identify potential flaws, perform comprehensive code reviews, and verify its security, precision, and adherence to industry best practices.',
    },
  ]
</script>

<div class="mx-auto max-w-[1700px]">
  <section
    class="relative m-2 flex flex-col justify-between overflow-hidden rounded-lg bg-[#24CAFF] text-black lg-desktop:mx-8"
  >
    <div
      class="relative flex h-[220px] items-center justify-center xl-mobile:h-[250px] xs-tablet:h-[300px] md:h-[420px] lg-desktop:h-[550px]"
    >
      <h2
        class="absolute top-4 z-[1] font-cirka text-[15vw] font-medium uppercase text-black xl-mobile:top-[40%] xl-mobile:text-[80px] xs-tablet:text-[95px] md:text-[145px] sm-desktop:top-[50%] sm-desktop:text-[180px] lg-desktop:text-[190px]"
      >
        Security
      </h2>
      <div class="absolute inset-x-0 top-[88px] w-full xl-mobile:top-[5px] sm-desktop:top-[-40px] xl:top-[-80px]">
        <ButaneImage
          layout="fullWidth"
          src={'security.png'}
          alt="security hero image"
          class="w-full rotate-[-4deg] scale-[1.2] object-cover xl:rotate-[-8deg]"
        />
      </div>
    </div>

    <ul
      class="relative z-[1] mt-[5vw] px-6 md:grid md:grid-cols-2 md:gap-4 md:space-y-0 md:border-t md:border-black md:pb-0 lg:mt-24 xl:mt-32 lg-desktop:mt-20"
    >
      {#each values as { title, desc }, index}
        <li
          class="space-y-8 border-t-[1px] border-t-black py-8 last:border-r-0 md:space-y-20 md:border-r md:border-t-0 md:border-black xl:pt-12"
        >
          <div class="flex h-[32px] w-[60px] items-center justify-center rounded-full bg-black">
            <p class="text-[#24CAFF]">0{index + 1}</p>
          </div>
          <div class="xl:space-y-6 xl:pb-16">
            <h3
              class="font-cirka text-3xl xl:pr-8 xl:text-[42px] xl:leading-[45px] lg-desktop:w-[210px] lg-desktop:text-[48px] lg-desktop:leading-[55px]"
            >
              {title}
            </h3>
            <p class="transfro mt-3 font-graphik leading-6 md:w-[325px] lg:text-[16px] lg-desktop:w-[375px]">{desc}</p>
          </div>
        </li>
      {/each}
    </ul>
  </section>
</div>
